import React, {useState} from 'react';
import IndicatorTypeTable from './table';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import {
    Paper,
    withStyles,
} from '@material-ui/core';
import { Row, Col } from "react-flexbox-grid";
import AddIndicatorType from './addIndicatorType';
import {Mutation, Query} from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';

const ADD_INDICATOR_TYPE = gql`
    mutation addIndicatorType($indicatorType: IndicatorTypeInput!) {
        addIndicatorType(indicatorType: $indicatorType) {
            id
            name
            description
            image
        }
    }
`;

const GET_INDICATOR_TYPES = gql`
  {
    allIndicatorTypes {
      _id
      name
      description
      image
    }
  }
`;

const UPDATE_INDICATOR_TYPE = gql`
    mutation($id: ID!, $indicatorType: IndicatorTypeInput!) {
        editIndicatorType(id: $id, indicatorType: $indicatorType) {
            _id
            id
            name
            description
            image
        }
    }
`;

const styles = theme => ({
    root : {
        position : 'relative',
        margin   : 36
    },
    fab : {
        position  : 'absolute',
        top       : 0,
        right     : 0,
        transform : `translateX(${50}%) translateY(${-50}%)`,
    }
})

/**
 * Componenete para el listado de tipos de indicadores, también se desencadenan
 * acciones de actualización y eliminación de tipos
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const ListIndicatorType = ({classes}) => {
    const [openAdd, setOpenAdd]           = useState(false);
    const [objectAction, setObjectAction] = useState(null);
    const [mutation, setMutation]         = useState(ADD_INDICATOR_TYPE);

    function handleOpenEdit(row){
        setObjectAction(row);
        setOpenAdd(!openAdd);
        setMutation(UPDATE_INDICATOR_TYPE);
    }

    function handleClose(){
        setObjectAction(null);
        setOpenAdd(false);
        setMutation(ADD_INDICATOR_TYPE); 
    }
    
    return(
        <Mutation
            mutation       = {mutation}
            refetchQueries = {() => [{ query: GET_INDICATOR_TYPES}]}
            onCompleted    = {() => handleClose()}
        >
            {postMutation => {
                return(
                    <Query query={GET_INDICATOR_TYPES}>
                        {({ loading, error, data }) => {

                            if (loading) return null;
                            if (error) return `Error!: ${error}`;
                            return (
                                <Row>
                                    <Col xs={12}>
                                        <Paper className={classes.root}>
                                        <Fab className={classes.fab} color={'primary'} onClick={() => setOpenAdd(true)}>
                                            <AddIcon/>
                                        </Fab>
                                        <IndicatorTypeTable
                                            data       = {data}
                                            openEdit   = {(row) => handleOpenEdit(row)}
                                            query      = {GET_INDICATOR_TYPES}
                                        />
                                        </Paper>
                                        {openAdd && 
                                            <AddIndicatorType
                                                open            = {openAdd}
                                                handleOpen      = {() => setOpenAdd(!openAdd)}
                                                onClose         = {() => handleClose()}
                                                onSubmit        = {postMutation}
                                                objectEdit      = {objectAction}
                                            />
                                        }
                                    </Col>
                                </Row>
                            );
                        }}
                    </Query>
                )}
            }
        </Mutation>
    );
};

ListIndicatorType.propTypes = {
    classes : PropTypes.object
}

export default withStyles(styles)(ListIndicatorType);



// WEBPACK FOOTER //
// ./src/components/admin/indicator-types/listIndicatorType.js